function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-449 -306)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(449 306)",
  fill: "#fff",
  stroke: "#f9f9f9",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 39,
  r: 39,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 39,
  r: 38.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  d: "M14.029,15.783A7.891,7.891,0,1,0,6.138,7.891,7.893,7.893,0,0,0,14.029,15.783Zm7.014,1.754h-3.02a9.539,9.539,0,0,1-7.99,0H7.014A7.014,7.014,0,0,0,0,24.551v.877a2.631,2.631,0,0,0,2.63,2.63h22.8a2.631,2.631,0,0,0,2.63-2.63v-.877A7.014,7.014,0,0,0,21.043,17.536Z",
  transform: "translate(473.458 330.458)",
  fill: "#1C0F59"
}));

function SvgBlankProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankProfile);
export default __webpack_public_path__ + "static/media/Blank_Profile.541a7c1dfee5523c93bf70fb4ba48790.svg";
export { ForwardRef as ReactComponent };